import UserRole from "./UserRole";
import { useState, useEffect } from "react";
import ProfileManagement from "./ProfileManagement";
import Subscription from "./Subscription";
import WorkspaceManagement from "./WorkSpaceManagement";
import api from "../../api/axios";
import "./Settings.css";
import Sidebarnew from "../NewUI/Sidebarnew";
import Navigationnew from "../NewUI/Navigationnew";

function Settings() {
  const [userType] = useState(() => {
    const stored = localStorage.getItem("userType");
    return stored === "company" || stored === "individual" ? stored : "individual";
  });

  const [permissions, setPermissions] = useState({ read_access: "", both_access: "", isAdmin: false });
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState("profile");

  useEffect(() => {
    const fetchPerms = async () => {
      try {
        const res = await api.get(`/user-roles/me?t=${new Date().getTime()}`);
        if (res.data.isAdmin) {
          setPermissions({ isAdmin: true, read_access: "ALL", both_access: "" });
        } else if (res.data.noRoleDefined) {
          setPermissions({ isAdmin: false, read_access: "ALL", both_access: "" });
        } else {
          setPermissions({ ...res.data, isAdmin: false });
        }
      } catch (err) {
        console.error("Settings permission check failed");
        setPermissions({ isAdmin: true, read_access: "ALL", both_access: "" });
      } finally {
        setLoading(false);
      }
    };
    fetchPerms();
  }, []);

  const hasAccess = (label) => {
    // Hard Override: Profile Management is ALWAYS allowed for everyone
    if (label === "Profile Management") return true;

    // Admin/Owner Bypass
    if (permissions.isAdmin || permissions.read_access === "ALL") return true;

    // Standard Permission Check
    const allowedRead = (permissions.read_access || "").split(",").map(s => s.trim());
    const allowedBoth = (permissions.both_access || "").split(",").map(s => s.trim());
    return allowedRead.includes(label) || allowedBoth.includes(label);
  };

  if (loading) return <div className="vh-100 settings-page-bg" />;

  return (
    <>
    <div className="db-page-layout settings-page">

        {/* SIDEBAR */}
        <aside className="db-sidebar-shell">
          <Sidebarnew />
        </aside>

        {/* MAIN */}
        <div className="db-main-wrapper">

          {/* HEADER */}
          <div className="db-topbar-shell">
            <Navigationnew
              setArtifactsOpen={() => {}}
              artifactsOpen={false}
            />
          </div>

          {/* SETTINGS PAGE */}
          <div className="settings-page-bg">
            <div className="settings-outer-wrapper">

              {/* Page Title */}
              <div className="settings-page-header">
                <h1 className="settings-page-title">Settings</h1>
                <p className="settings-page-subtitle">Manage your account, preferences, and integrations.</p>
              </div>

              {/* Two-column layout: left nav + right content */}
              <div className="settings-layout">

                {/* ── LEFT VERTICAL NAV ── */}
                <nav className="settings-vertical-nav">
                  {hasAccess("Profile Management") && (
                    <button
                      className={`settings-vnav-btn ${activeTab === "profile" ? "active" : ""}`}
                      onClick={() => setActiveTab("profile")}
                    >
                      <img src="/images/set1.svg" alt="General" className="settings-vnav-icon" />
                      General
                    </button>
                  )}

                  {hasAccess("Workspace Management") && (
                    <button
                      className={`settings-vnav-btn ${activeTab === "workspace" ? "active" : ""}`}
                      onClick={() => setActiveTab("workspace")}
                    >
                      <img src="/images/set2.svg" alt="Workspace Management" className="settings-vnav-icon" />
                      Workspace Management
                    </button>
                  )}

                  {hasAccess("User Role") && (
                    <button
                      className={`settings-vnav-btn ${activeTab === "role" ? "active" : ""}`}
                      onClick={() => setActiveTab("role")}
                    >
                      <img src="/images/set3.svg" alt="User Role" className="settings-vnav-icon" />
                      User Role
                    </button>
                  )}

                  {hasAccess("Subscription") && (
                    <button
                      className={`settings-vnav-btn ${activeTab === "subscription" ? "active" : ""}`}
                      onClick={() => setActiveTab("subscription")}
                    >
                      <img src="/images/set4.svg" alt="Billing" className="settings-vnav-icon" />
                      Billing
                    </button>
                  )}
                </nav>

                {/* ── RIGHT CONTENT AREA ── */}
                <div className="settings-content-panel">
                  {activeTab === "profile" && hasAccess("Profile Management") && <ProfileManagement />}
                  {activeTab === "workspace" && hasAccess("Workspace Management") && <WorkspaceManagement />}
                  {activeTab === "role" && hasAccess("User Role") && <UserRole />}
                  {activeTab === "subscription" && hasAccess("Subscription") && <Subscription />}
                </div>

              </div>
            </div>
          </div>

        </div>
      </div>
    </>
  );
}

export default Settings;